export default "__VITE_ASSET__CvgxIp4r__"